module.exports = __webpack_public_path__ + "img/photo-of-couple.5c690083.jpg";